
/*
** This file is auto generated by the gen-version-file script.
** Don't edit this file manually, instead, run yarn nx gen-version-file <project>
** to update it.
*/
export const PACKAGE_NAME='@cbhq/identity-fingerprint'
export const PACKAGE_VERSION='0.6.6'
export const PACKAGE_VERSION_NAME='@cbhq/identity-fingerprint--0.6.6'
